export {
    SimpleImageTextSide,
    type ImagePositions,
    type SideBySideProps
} from "./simple-image-text-side";
export { SimpleImageTextSide as default } from "./simple-image-text-side";
